<template>
  <div id="data-view">
    <!-- <dv-full-screen-container> -->
    <template v-if="false">
      <dv-loading>Loading...</dv-loading>
    </template>

    <template v-else>
      <div class="parent">
        <!-- 头部 -->
        <div class="div1" style="grid-area: 1 / 1 / 2 / 6">
          <div class="header_logo">
            <img src="./img/logo.png" alt="" />
          </div>
          <div class="header_title">
            <img src="./img/text.png" alt="" /> 
          </div>
          <div class="header_time">
            <span>{{ currentTime.date }}</span>
            <span>{{ currentTime.time }}</span>
          </div>
          <!-- <div class="header_bottom"></div> -->
        </div>
        <!-- 会议室预定分析 -->
        <div class="div2" style="grid-area: 2 / 1 / 3 / 6">
          <!-- <air-quality /> -->
          <!-- <scheduled-analysis :meeting-info='meetingInfo' :meeting-total='meetingTotal'> </scheduled-analysis> -->
            <scheduled-analysis > </scheduled-analysis>
        </div>
        <!-- 蜂鸟地图 -->
        <div class="div3" style="grid-area: 3 / 1 / 6 / 6">
          <fengmap
            :app-key="config.fengmap.key"
            :app-name="config.fengmap.appname"
            :map-id="mapSetting.map_id"
            :areas="meetingRooms"
            default-theme-name="e1fe25da82f50b610f4422b6fdf5b807"
          />
          <div class="dian">
             <img src="./img/group.png" alt="">
          </div>
        </div>
        <!-- 会议室轮博 -->
        <div class="div4" style="grid-area: 6 / 1 / 10 / 6">
          <meeting-status-board
            :areas="meetingRooms"
            :current-time="currentTime"
          />
        </div>
        <div class="div5" style="grid-area: 10 / 1 / 12 / 6">
          <phone-booth :recapture-data="recaptureData" :areas="publicZones"  :areas-by-area-id="AreasByAreaId"/>
          <!-- :sts-usage-rate="stsUsageRate" -->
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import ScheduledAnalysis from "./components/ScheduledAnalysis"
import fengmap from "../components/fengmap";
import meetingStatusBoard from "./meetingStatusBoard";
import phoneBooth from "./phoneBooth";
import config from "../config";
import { get } from "lodash";
import * as api from "../services/api";
import dayjs from "dayjs";
// import RoomBoard from "./roomBoard.vue";
import { debounce } from "lodash";
import { io } from "socket.io-client";
import moment from "moment";
import AirQuality from "./airQuality.vue";
import { addMeetingState } from "../utils/meetingUtil";

export default {
  name: "DataView",
  components: {
    fengmap,
    meetingStatusBoard,
    phoneBooth,
    AirQuality,
    ScheduledAnalysis
  },

  data() {
    return {
      AreasByAreaId:[],
      recaptureData:{},
      // stsUsageRate:[],
      // meetingTotal:{},
      // meetingInfo:{},
      config,
      meetingRooms: [],
      publicZones: [],
      location: {},
      loading: true,
      socketConnected: false,

      currentTime: {
        unix: "",
        date: "",
        time: "",
      },
    };
  },
  computed: {
    mapSetting: function () {
      const mapSetting = get(this.location, "settings.map");
      // console.log("mapSetting: ", mapSetting);
      return mapSetting;
    },
  },
  created(){
      this.loadData();
  },
  mounted: function () {
     
  
    setInterval(() => {
      this.loadData();
    }, 10 * 60 * 1000); // load data every 10 minutes
    this.initWebSocket();
    this.setCurrentTime();
    setInterval(() => {
      if (dayjs().second() === 0) {
        this.setCurrentTime();
        // 更新status
        if (this.meetingRooms) {
          this.meetingRooms.forEach((room) => addMeetingState(room));
        }
      }
    }, 1 * 1000); // check every 1 second
  },
  methods: {
    // ...mapActions(['getLocation', 'getFloorInfos', 'getAreas', 'getVisitors', 'getReservations', 'getCentrifugeToken']),
    get,
    // 设置当前时间
    setCurrentTime() {
      this.currentTime = {
        date: moment().format("YYYY年MM月DD日"),
        time: moment().format("HH:mm"),
        unix: moment(moment().format("YYYY-MM-DD HH:mm")).unix(),
      };
    },
    // 防抖函数
    debounceLoadData: debounce(
      function () {
        // console.log("**** debounce");
         this.loadMeetingRooms();
         // 会议室次数时长人数
        // this.loadMeetingTotals()
        // 会议室使用情况
          //  this.loadMeetingStatus();
       // console.log("*** this.meetingRooms", this.meetingRooms);
         this.loadPublicZones();
       
        // 场地按天使用率
        //  this.getMeetingUsageRate()
        // 会议室重复使用率以及时间
           this.meetingRecaptureData()
        // 按场地统计总会议次数，参与人数，总时长
           this.getAreasByAreaId()
        

      },
      1000,
      { maxWait: 2000 }
    ),
    loadData: async function () {
      // const today = dayjs()
      // console.log('loading location: ', locationId)
      this.location = (await api.getLocation(config.locationId)).data;
      await this.loadMeetingRooms();
      // 会议室使用情况
      // await this.loadMeetingStatus();
      // console.log("*** this.meetingRooms", this.meetingRooms);
      await this.loadPublicZones();
       // 场地按天使用率
      // await this.getMeetingUsageRate()
      // 会议室重复使用率以及时间
      await this.meetingRecaptureData()
      // 按场地统计总会议次数，参与人数，总时长
      await this.getAreasByAreaId()
      // 会议室次数时长人数
      // await this.loadMeetingTotals()
      // console.log("*** getPublicZones", this.publicZones);
      this.loading = false;
    },
    // 会议室重复使用率以及时间
    meetingRecaptureData:async function(){
        const resp= await api.meetingRecaptureData({
         location_id:config.locationId,
         start_date: dayjs().subtract('1','week').format('YYYY-MM-DD'),
         end_date: dayjs().format('YYYY-MM-DD'),
      })
      this.recaptureData=resp.data
    },
    // 场地按天使用率
    // getMeetingUsageRate:async function(){
    //   const resp= await api.getMeetingUsageRate({
    //      location_id:config.locationId,
    //      start_date: dayjs().subtract('1','week').format('YYYY-MM-DD'),
    //      end_date: dayjs().format('YYYY-MM-DD'),
    //      include_last:true
    //    })
    //    const {stats,last_month_stats} = resp.data
    //    console.log(stats,last_month_stats);
    //    const stsUsageRate = stats.map((d, index) => ({
    //           date: dayjs(d.date).format('MM-DD'),
    //           thisMonth: d.usage_rate,
    //           lastMonth: last_month_stats[index].usage_rate || 0,
    //    }));
    //    this.stsUsageRate=stsUsageRate
    // },
    // 按场地统计总会议次数，参与人数，总时长
      getAreasByAreaId:async function(){
       const resp3 = await api.getAreasByAreaId({
          location_id:config.locationId,
          start_date: dayjs().subtract('1','week').format('YYYY-MM-DD'),
          end_date: dayjs().format('YYYY-MM-DD'),
       })
       this.AreasByAreaId=resp3.data.stats
       console.log(resp3);
      },
    // 会议室次数时长人数
    loadMeetingTotals:async function(){
      const resp2= await api.getMeetingTotals(config.locationId,{
           start_date: dayjs().subtract('1','month').format('YYYY-MM-DD'),
           end_date: dayjs().format('YYYY-MM-DD'),
        })
        this.meetingTotal=resp2.data.stats
    },
    // 会议室使用情况
    // loadMeetingStatus:async function(){
    //     const resp= await api.getMeetingStatus(config.locationId,{
    //        start_at: dayjs().subtract('1','month').format('YYYY-MM-DD'),
    //        end_at: dayjs().format('YYYY-MM-DD'),
    //     })
    //     this.meetingInfo = resp.data
    // },
    loadMeetingRooms: async function (area_ids) {
      this.meetingRooms = (
        await api.getMeetingRooms(config.locationId, {
          area_ids,
          per_page: 1000,
          start_at: dayjs().format(),
          end_at: dayjs().add(1, "minute").format(),
          includes: "reservations,settings,floor_info",
          // state: "free,assigned",
        })
      ).data;
      this.meetingRooms.forEach((room) => addMeetingState(room));
    },
    refreshRoom: async function (areaId) {
      const area = (
        await api.getMeetingRooms(config.locationId, {
          area_ids: [areaId],
          per_page: 1000,
          start_at: dayjs().format(),
          end_at: dayjs().add(1, "minute").format(),
          includes: "reservations,settings,floor_info",
          // state: "free,assigned",
        })
      ).data;
      addMeetingState(area);
      const areas = [...this.meetingRooms];
      const index = areas.findIndex((x) => x.id == area.id);
      areas.splice(index, 1, area);
      this.meetingRooms = areas;
    },
    loadPublicZones: async function () {
      this.publicZones = (
        await api.getPublicZones(config.locationId, {
          per_page: 1000,
          start_at: dayjs().format(),
          end_at: dayjs().add(1, "minute").format(),
        })
      ).data;
    },
    initWebSocket: function () {
      const socket = io(config.socket_url);

      const that = this;
      // const { currentUser, currentLocation } = this.props;
      socket.on("Reservation", (message) => {
        console.log("**** socket io message received: ", message);
        if (message.room === `Location_${config.locationId}`) {
          //TODO: taoh - why debounce doesn't work??
          // 需要将防抖写成一个函数，声明的函数对应debounce的返回值
          // 参考：https://blog.csdn.net/qq_25131799/article/details/104921548
          that.debounceLoadData();
        }
      });

      socket.on("Area", (message) => {
        console.log("**** socket io message received: ", message);
        if (message.room === `Location_${config.locationId}`) {
          //TODO: taoh - why debounce doesn't work??
          // 需要将防抖写成一个函数，声明的函数对应debounce的返回值
          // 参考：https://blog.csdn.net/qq_25131799/article/details/104921548
          that.debounceLoadData();
        }
      });

      socket.on("connect", () => {
        console.log("**** socket connected: ", socket.id);
        socket.emit("subscribe", `Location_${config.locationId}`);

        that.socketConnected = true;
      });

      socket.on("disconnect", () => {
        console.log("**** socket disconnect: ", socket.id);
        that.socketConnected = false;
      });
    },
  },
};
</script>

<style lang="less">
#data-view {
  width: 1080px;
  height: 1920px;
  // height: 100%;
  // width: 100%;
  background:url(./img/background.png);
  // background-position:bottom 72px left 0px;
  background-size: 100% 100%;


  #dv-full-screen-container {
    // background-image: url("./img/bg.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
  }
}

.parent {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(11, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 6px;

  // display: grid;
  // grid-template-columns: repeat(20, 1fr);
  // grid-template-rows: repeat(20, 1fr);
  // grid-column-gap: 10px;
  // grid-row-gap: 10px;
  // height: 100%;
  // border-bottom: 2px solid rgba(60, 110, 255, 0.3);
  // margin: 0 40px;
}

.parent > div {
  /*background-color: rgba(255, 255, 255, 0.8);*/
}
.div1 {
  height: 123px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  // margin-top: -35px;
  .header_logo {
    width: 259px;
    height: 26px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .header_title {
    font-size: 42px;
    margin-left: -140px;
    font-weight: bold;
    color: #ffffff;
  }
  .header_time {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    span:nth-of-type(1) {
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      line-height: 21px;
    }
    span:nth-of-type(2) {
      font-size: 26px;
      //font-family: DINPro-Bold, DINPro;
      font-weight: bold;
      color: #ffffff;
      line-height: 33px;
    }
  }
  // .header_bottom {
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   background-image: url("./img/header.png");
  //   background-size: 100% 100%;
  //   background-position: bottom center;
  //   background-repeat: no-repeat;
  //   width: 100%;
  //   height: 50px;
  // }
}
.div2 {
  margin:7px 0px  30px ;
  height: 122px;
  // display: flex;
  // padding: 10px 0;
  // border-top: 4px solid rgba(60, 110, 255, 0.3);
  // border-bottom: 4px solid rgba(102, 161, 201, 0.15);
  // background-color: rgba(26, 27, 51, 0.6);
}
.div3 {
  // border-top: 4px solid rgba(60, 110, 255, 0.3);
  // border-bottom: 4px solid rgba(102, 161, 201, 0.15);
  // background-color: pink;
  width: 100%;
  margin:20px 0px ;
  // padding-right:20px;
  // padding-left: 20px;
  // height: 440px;
  // height: 420px;
  // left: 77px;
  // top: 342px;
  .dian{
    height: 20px;
    width: 100%;
    margin: 20px;
    img{
     width: 96.5%;
     height: 100%;
    }
  }


}
.div4 {
  // border-bottom: 4px solid rgba(102, 161, 201, 0.15);
  // height: 400px;
  // background-color: pink;
  margin: 30px 20px 0 ;
  background: url(./img/mettingtable.png) no-repeat;
 background-size: 103.5% 105%;
  background-position: left -18px bottom -15px ;

}
.div5 {
  // border-top: 4px solid rgba(60, 110, 255, 0.3);
  // border-bottom: 4px solid rgba(102, 161, 201, 0.15);
}
</style>
